import { EButton, ETextInput } from "libs/ui";
import { FaRegEdit } from "react-icons/fa";

interface EditableFieldProps {
  label: string;
  value: string;
  placeholder?: string;
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
  type?: string;
minLength?: number;
  maxLength?: number;
}

const EditableField = ({
  label,
  value,
  placeholder,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  onChange,
  type = "text",
  minLength,
  maxLength,
}: EditableFieldProps) => {
  return (
    <div className="flex items-center gap-2">
      <label className="text-slate-500 text-md font-normal capitalize whitespace-nowrap">
        {label}:
      </label>

      {isEditing ? (
        <ETextInput
          type={type}
          value={value}
          placeholder={placeholder}
          minLength={minLength}
          maxLength={maxLength}
          onChange={(e) => onChange(e.target.value)}
          className="text-slate-500 text-md font-normal"
        />
      ) : (
        <p className="text-slate-500 text-md font-normal whitespace-nowrap">
          {value}
        </p>
      )}

      {isEditing ? (
        <>
          <EButton size="xs" onClick={onSave}>
            Save
          </EButton>

          <EButton size="xs" onClick={onCancel}>
            Cancel
          </EButton>
        </>
      ) : (
        <FaRegEdit
          className="cursor-pointer text-slate-400 hover:text-slate-500"
          size={16}
          onClick={onEdit}
        />
      )}
    </div>
  );
};

export default EditableField;